export const selectSelectedConsultation = (state) =>
  state?.consultation?.selectedConsultation ?? null;

export const selectPatientConsultations = (state) =>
  state?.consultation?.patientConsultations ?? [];

export const selectDoctorConsultations = (state) =>
  state?.consultation?.doctorConsultations ?? [];

export const selectConsultationLoading = (state) =>
  state?.consultation?.loading ?? false;

export const selectConsultationError = (state) =>
  state?.consultation?.error ?? null;

export const selectConsultationSuccess = (state) =>
  state?.consultation?.success ?? false;

export const selectPatientConsultationCount = (state) =>
  state?.consultation?.patientConsultations?.length ?? 0;

export const selectDoctorConsultationCount = (state) =>
  state?.consultation?.doctorConsultations?.length ?? 0;

/* 🔁 Backward compatibility */
export const selectConsultationsByPatientId = selectPatientConsultations;
export const selectConsultationsByDoctorId = selectDoctorConsultations;
export const selectConsultationsLoading = selectConsultationLoading;
export const selectConsultationsError = selectConsultationError;
